export default function HowItWorksSection() {
  const steps = [
    {
      number: "01",
      icon: "ri-radar-line",
      title: "Detect Activity",
      subtitle: "Real-time market intelligence",
      desc: "Imperium monitors MLS listings, pending closings, and loan officer pre-approvals across your territory in real time. The moment something moves, we know about it.",
      detail: "New listing, closing pending, or pre-approval issued",
    },
    {
      number: "02",
      icon: "ri-phone-fill",
      title: "Trigger Outreach",
      subtitle: "AI places the call within seconds",
      desc: "A natural-sounding AI voice call is placed to the relevant agent or loan officer — introducing your team, positioning your services, and starting a real conversation.",
      detail: "Average 2.3 seconds from trigger to call",
    },
    {
      number: "03",
      icon: "ri-arrow-right-up-line",
      title: "Route Opportunity",
      subtitle: "Warm handoff to your closer",
      desc: "When a contact shows interest, Imperium routes the opportunity directly to your team with full context — so your closer can follow up with everything they need to win.",
      detail: "Warm leads delivered with full call summary",
    },
  ];

  return (
    <section id="how-it-works" className="bg-white py-14 md:py-24 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-alt-bg border border-gray-200 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-settings-3-line text-navy text-xs" />
            <span className="text-xs font-semibold text-navy">Simple Process</span>
          </div>
          <h2
            className="text-navy font-semibold mb-4"
            style={{ fontSize: "clamp(26px, 3vw, 38px)", lineHeight: "1.2" }}
          >
            How You Get Every Closing Before It&apos;s Decided
          </h2>
          <p className="text-[#4a5568] text-base" style={{ lineHeight: "1.65" }}>
            Three steps. Fully automated.<br />You get the conversation — your team gets the closing.
          </p>
        </div>

        <div className="flex flex-col md:grid md:grid-cols-3 md:gap-6 relative">
          {/* Connector lines (desktop only) */}
          <div className="hidden md:block absolute top-[52px] left-[calc(33.33%+1.5rem)] right-[calc(33.33%+1.5rem)] h-px bg-gray-200" />

          {steps.map((step, index) => (
            <div key={step.number} className="relative">

              {/* ── Mobile: vertical timeline layout ── */}
              <div className="flex md:hidden gap-4">
                {/* Left column: icon + connecting line */}
                <div className="flex flex-col items-center flex-shrink-0">
                  <div className="w-12 h-12 flex items-center justify-center bg-navy rounded-2xl flex-shrink-0 z-10">
                    <i className={`${step.icon} text-white text-lg`} />
                  </div>
                  {index < steps.length - 1 && (
                    <div className="w-px bg-gray-200 flex-1 mt-2 min-h-[60px]" />
                  )}
                </div>

                {/* Right column: text content */}
                <div className={`flex-1 min-w-0 ${index < steps.length - 1 ? "pb-8" : "pb-2"}`}>
                  <p className="text-[#f1663a] text-xs font-bold uppercase tracking-widest mb-0.5">
                    Step {step.number}
                  </p>
                  <p className="text-[#4a5568] text-xs mb-3">{step.subtitle}</p>
                  <h3 className="text-navy font-semibold text-lg mb-2">{step.title}</h3>
                  <p className="text-[#4a5568] text-sm leading-relaxed mb-3">{step.desc}</p>
                  <div className="inline-flex items-center gap-2 bg-alt-bg rounded-lg px-3 py-2">
                    <span className="w-3.5 h-3.5 flex items-center justify-center text-green-500 flex-shrink-0">
                      <i className="ri-check-line text-xs" />
                    </span>
                    <span className="text-[#4a5568] text-xs">{step.detail}</span>
                  </div>
                </div>
              </div>

              {/* ── Desktop: original column layout ── */}
              <div className="hidden md:flex flex-col items-start">
                <div className="flex items-center gap-4 mb-6 w-full">
                  <div className="w-14 h-14 flex items-center justify-center bg-navy rounded-2xl relative z-10">
                    <i className={`${step.icon} text-white text-xl`} />
                  </div>
                  <div>
                    <p className="text-[#f1663a] text-xs font-bold uppercase tracking-widest">
                      Step {step.number}
                    </p>
                    <p className="text-[#4a5568] text-xs">{step.subtitle}</p>
                  </div>
                </div>
                <h3 className="text-navy font-semibold text-xl mb-3">{step.title}</h3>
                <p className="text-[#4a5568] text-sm leading-relaxed mb-4">{step.desc}</p>
                <div className="flex items-center gap-2 bg-alt-bg rounded-lg px-3 py-2">
                  <span className="w-3.5 h-3.5 flex items-center justify-center text-green-500">
                    <i className="ri-check-line text-xs" />
                  </span>
                  <span className="text-[#4a5568] text-xs">{step.detail}</span>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
